window.addEventListener('DOMContentLoaded', () => {
  const testimonialSwiper = document.querySelectorAll('.testimonial-slider');

  [].forEach.call(testimonialSwiper, (swiperInstance) => {
    const testimonialInner = swiperInstance.querySelector('.testimonial-slider__inner');
    new Swiper(testimonialInner, {
      slidesPerView: 'auto',
      speed: 1000,
      watchOverflow: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });
});
